import { useRef } from "react";
import { allStates } from "./allStatates";

export default function StateSel({handleChange, formData}){
    
    const selRef = useRef(null);

    const getLabel = (st) => {
        allStates.states.map((v) => {
            if(st === v.key){
                return v.label
            }
        })
    }

    const GetValues = () => {

        return(
            <>
            {
                allStates.states.map((v,i) => (
                    <option defaultValue="--Jursdiction--" key={v.key} label={v.label} slected={v.label} value={v.key}>
                        {getLabel(v.key)}
                    </option>

            ))}</>
        )
    }

    return(
        <div>
            <select className="form-control form-select"
                value={formData.userState}
                onChange={(e) => handleChange(e)}
                name="userState"
                defaultValue={""}
                ref={selRef}
                required
            >
                <option value="">-- Jurisdiction --</option>
                <GetValues />
            </select>
        </div>

    )

}